/*

  m a t c h i ng  i n t e r f a c e
  Matching Interface

  :description:
  A class that can load matches from the cloud.

*/

//
//  :code:
import { loadJSONF, postJSONF } from '../js/requests'
import { talk } from '../js/talk'
import { safeAssembleUrl } from '../js/utils'

//
//  :statics:
//  Variables and static declarations.
export const EYEKANDY_MATCHING_INTERFACE = 'EyekandyMatchingInterface'

//
//  :classes:
export class EyekandyMatchingInterface {
  constructor(options) {
    if (typeof options === 'undefined') {
      options = {}
    }
    //
    //  :core:
    //  Core settings and values.
    this.name = 'eyekandy-matching-interface'
    this.version = 'v4.0.0'
    this.group = '[EYEKANDY-MATCHING-INTERFACE]'

    //
    //  :runtime:
    this.environment = options.environment || 'dev'
    this.urls = {
      dev: `https://network-dev.pointandplace.com/resolve/`,
      prod: `https://network.pointandplace.com/resolve/`,
    }

    //
    //  :echo:
    //  Write out into the console that the instance was created.
    talk([this.group, `created a new instance @ '${this.version}'`])
  }

  //
  //  :api:
  //  Exposed API functions for callers.
  //  -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -   =   -

  async resolveMatches(distributor, services, language, skuOrSKUs, eanOrEans, mpnOrMPNs, upcOrUPCs, urlOrURLs) {
    //
    //  :step 1:
    //  Assemble our URL.
    const d = distributor ? `${distributor}` : 'anonymous'
    const baseUrl = this.urls[this.environment] + d
    const mapping = {
      distributor: distributor,
      services: services,
      language: language,
      skus: skuOrSKUs,
      eans: eanOrEans,
      mpns: mpnOrMPNs,
      upcs: upcOrUPCs,
      urls: urlOrURLs,
    }

    //
    //  If our mapping is > than 2 kB we need to POST.
    const GET_REQUEST_CHARACTER_LIMIT = 2000
    const method = JSON.stringify(mapping).length > GET_REQUEST_CHARACTER_LIMIT ? 'POST' : 'GET'
    let result = null
    if (method === 'GET') {
      //
      //  Join all our arguments together, but only if required.
      const argsToJoin = ['services', 'skus', 'mpns', 'eans', 'upcs', 'urls']
      //
      //  Ok, request our matches.
      result = await loadJSONF(safeAssembleUrl(baseUrl, mapping, argsToJoin))
    }
    if (method === 'POST') {
      //
      //  Posting the data is just a one step process.
      result = await postJSONF(baseUrl, mapping)
    }

    //
    //  All done, return the config to the caller.
    return result
  }
}
